import { defineStore } from "pinia";
import api from "../api/axios";

export const useLanguageStore = defineStore("language", {
  state: () => ({
    languages: [],
    loaded: false,
    loading: false,
  }),

  actions: {
    async loadLanguages() {
      if (this.loaded || this.loading) return;

      try {
        this.loading = true;
        const { data } = await api.get("/account/language");

        this.languages = data;
        this.loaded = true;
      } catch (err) {
        console.error("Ошибка загрузки языков:", err);
      } finally {
        this.loading = false;
      }
    },
  },
});
